import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { MerchCardColumns } from 'pricing-pages-ui-components/components/MerchCardColumns';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { useState } from 'react';
import { HUBSPOT_CREDITS_CARDS_SECTION } from '../../../v2/constants/tracking/TrackingSources';
import { useHubSpotCreditsInventoryInfo } from '../../../v2/hooks/inventory/useHubSpotCreditsInventoryInfo';
import ProductAndServicesCatalogLink from '../../ProductAndServicesCatalogLink';
import MobileMerchCardSelectorButtons from '../../mobile/MobileMerchCardSelectorButtons';
import HubSpotCreditsTile from './HubSpotCreditsTile';
import { SIZE_TO_LOCATION_MAP } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const HubSpotCreditsTilesContainer = ({
  subscreen,
  unlockHubSpotCreditsSkuIds,
  title,
  subtitle
}) => {
  const isMobile = useIsMobile();
  const [selectedSize, setSelectedSize] = useState('SMALL');
  const {
    ownedHubSpotCreditsTotal,
    loading: hubSpotCreditsLoading
  } = useHubSpotCreditsInventoryInfo();
  const ownsAdditionalCredits = !hubSpotCreditsLoading && ownedHubSpotCreditsTotal > 0;
  const header = /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "800",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h2",
      typography: "heading-400",
      textAlign: "center",
      children: title
    }), /*#__PURE__*/_jsx(Text, {
      textAlign: "center",
      children: subtitle !== null && subtitle !== void 0 ? subtitle : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.hubspot-credits.unlockAI.subtitle"
      })
    })]
  });
  const footer = /*#__PURE__*/_jsx(Flex, {
    justifyContent: "center",
    children: /*#__PURE__*/_jsx(ProductAndServicesCatalogLink, {
      trackingSource: HUBSPOT_CREDITS_CARDS_SECTION,
      section: "#HubSpotCreditsRateSheet",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.pages.hubspot-credits.links.viewCreditsRateSheet"
      })
    })
  });
  if (isMobile) {
    return /*#__PURE__*/_jsxs(View, {
      as: "section",
      marginBlockEnd: "1100",
      children: [ownsAdditionalCredits ? null : /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "800",
        children: /*#__PURE__*/_jsx(MobileMerchCardSelectorButtons, {
          options: ['SMALL', 'MEDIUM', 'LARGE'],
          onClick: setSelectedSize,
          selectedOption: selectedSize
        })
      }), header, ownsAdditionalCredits ? null : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(MerchCardColumns, {
          columns: 1,
          marginBlockStart: "500",
          marginBlockEnd: "800",
          maxInlineSize: "initial",
          children: /*#__PURE__*/_jsx(HubSpotCreditsTile, {
            size: selectedSize,
            location: SIZE_TO_LOCATION_MAP[selectedSize],
            subscreen: subscreen,
            unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
            columnStart: 1,
            isCollapsible: true
          })
        }), footer]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    as: "section",
    marginBlockEnd: "1300",
    children: [header, ownsAdditionalCredits ? null : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(MerchCardColumns, {
        columns: 3,
        marginBlockEnd: "800",
        children: [/*#__PURE__*/_jsx(HubSpotCreditsTile, {
          size: "SMALL",
          location: "HUBSPOT_CREDITS_MERCH_CARD_SMALL",
          subscreen: subscreen,
          unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
          columnStart: 1
        }), /*#__PURE__*/_jsx(HubSpotCreditsTile, {
          size: "MEDIUM",
          location: "HUBSPOT_CREDITS_MERCH_CARD_MEDIUM_LARGE",
          subscreen: subscreen,
          unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
          columnStart: 2
        }), /*#__PURE__*/_jsx(HubSpotCreditsTile, {
          size: "LARGE",
          location: "HUBSPOT_CREDITS_MERCH_CARD_MEDIUM_LARGE",
          subscreen: subscreen,
          unlockHubSpotCreditsSkuIds: unlockHubSpotCreditsSkuIds,
          columnStart: 3
        })]
      }), footer]
    })]
  });
};